module.exports = __webpack_public_path__ + "static/media/setting-active-icon.7aea55cf.svg";